"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemotePeers = void 0;
var react_1 = require("react");
var useDitto_1 = require("../useDitto");
function useRemotePeers(params) {
    if (params === void 0) { params = {}; }
    var ditto = (0, useDitto_1.useDitto)(params.path).ditto;
    var _a = (0, react_1.useState)([]), remotePeers = _a[0], setRemotePeers = _a[1];
    (0, react_1.useEffect)(function () {
        var observer;
        if (ditto) {
            observer = ditto.presence.observe(function (_a) {
                var peers = _a.remotePeers;
                setRemotePeers(peers);
            });
        }
        else {
            setRemotePeers([]);
            observer = undefined;
        }
        return function () {
            observer === null || observer === void 0 ? void 0 : observer.stop();
        };
    }, [ditto]);
    return {
        ditto: ditto,
        remotePeers: remotePeers,
    };
}
exports.useRemotePeers = useRemotePeers;
//# sourceMappingURL=useRemotePeers.js.map